/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'confluence-analytics-byline.abbreviated-user-views.message':
    '{count, plural, =0 {Zobrazení} one {1} few {{count}} many {{count}} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Pozorovatelé',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Analytika} one {Zobrazeno 1 osobou} few {Zobrazeno {count} lidmi} many {Zobrazeno {count} lidmi} other {Zobrazeno {count} lidmi}}',
};
